import { LineChartComponent } from '../charts/line-chart-component'

export class AFCompareSovByImpressionsSpline extends LineChartComponent {
 static config = {
  selector: 'afCompareSovByImpressionsSpline',
  controller: AFCompareSovByImpressionsSpline,
  bindings: LineChartComponent.config.bindings,
  template: LineChartComponent.config.template,
 }

 setProperties() {
  this.removeAll = false
  this.isCompare = true
  this.seriesColors = this.colorUtils.compareMetaColors(this.visualizationMetaData)
 }

 onPointClick = obj => {
  let payload = []
  payload.push(this.updatePayloadDate(obj.key, obj.key))
  this.triggerUpdate(payload)
 }
}
